import { MailContact } from "../../types";
import EventBus from "../event-bus";
const getContactDetailHook = new EventBus<MailContact>("getContactDetailHook");

export default getContactDetailHook;
